import React from "react";
import {useTranslation} from "react-i18next";
import SpaceBetween from "@awsui/components-react/space-between";
import NavigationBar from "components/NavigationBar";
import PalmaresTable from "./components/PalmaresTable";
import Header from "@awsui/components-react/header";
import Container from "@awsui/components-react/container";


const PalmaresPage: React.FC = () => {
    const {t} = useTranslation("palmares");
    return (
        <SpaceBetween size={"l"}>
            <NavigationBar/>
            <Container
                variant={"default"}
                header={
                    <Header variant={"h2"}>
                        {t("title")}
                    </Header>
                }
            >
                <PalmaresTable />
            </Container>
        </SpaceBetween>
    );
};

export default PalmaresPage;
